const MEMORY_KEEPER_TOUR_TARGETS = Object.freeze({
    CHAPTER: 'chapter',
    THREAD: 'thread',
    COMPOSER: 'composer',
    MEMORIES_TAB: 'memories-tab'
});

function getTourTargetSelector(target) {
    return `[data-tour="${target}"]`;
}

const DEFAULT_TOUR_STAGE = Object.freeze({
    stagePadding: 8,
    stageRadius: 16
});

const PILL_TOUR_STAGE = Object.freeze({
    stagePadding: 2,
    stageRadius: 999
});

const MEMORY_KEEPER_TOUR_STEPS = [
    {
        element: getTourTargetSelector(MEMORY_KEEPER_TOUR_TARGETS.CHAPTER),
        data: { stepKey: 'chapter' },
        popover: {
            title: 'Start with a chapter',
            description: 'Pick the part of your life you want to talk about. Every five memories complete a chapter.',
            side: 'bottom',
            align: 'start'
        }
    },
    {
        element: getTourTargetSelector(MEMORY_KEEPER_TOUR_TARGETS.THREAD),
        data: { stepKey: 'thread' },
        popover: {
            title: 'Answer a few questions',
            description: 'We ask about your life one question at a time. Answer in your own words — there are no wrong answers.',
            side: 'bottom',
            align: 'center'
        }
    },
    {
        element: getTourTargetSelector(MEMORY_KEEPER_TOUR_TARGETS.COMPOSER),
        data: { stepKey: 'composer' },
        popover: {
            title: 'Write your memory here',
            description: 'A single sentence is enough to get started. You can always add more later.',
            side: 'top',
            align: 'center'
        }
    },
    {
        element: getTourTargetSelector(MEMORY_KEEPER_TOUR_TARGETS.MEMORIES_TAB),
        data: { stage: PILL_TOUR_STAGE, stepKey: 'memories_tab' },
        popover: {
            title: 'Find everything in Memories',
            description: 'Switch to Memories to see all your chapters and read the memories you have already unlocked.',
            side: 'bottom',
            align: 'center'
        }
    }
];

export {
    MEMORY_KEEPER_TOUR_TARGETS,
    MEMORY_KEEPER_TOUR_STEPS,
    DEFAULT_TOUR_STAGE,
    getTourTargetSelector
};
